import guideTeacher from "./guide-teacher.vue";

let Plugin = {},
  vueClass = Vue.extend(guideTeacher),
  vueInstance;

Plugin.install = function(Vue, opt) {
  opt.root.guideTeacher = function() {
    if (!vueInstance) {
        let el = document.createElement("div");
        document.querySelector("body").appendChild(el);

        vueInstance = new vueClass({
        el: el,
        router: opt.router,
        });
    }

    return vueInstance;
    // return vueInstance.show(...arguments);
  };
};

export default Plugin;
